import React, { useState } from "react";

function BookOnline() {
  const [bookingData, setBookingData] = useState({
    fullName: "",
    email: "",
    mobileNumber: "",
    country: "",
    kgs: "",
    shipmentDetails: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setBookingData({ ...bookingData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        "http://localhost:8080/booking/create",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            ...bookingData,
            kgs: Number(bookingData.kgs) // backend expects number
          })
        }
      );

      const result = await response.json();

      if (!response.ok) {
        alert("Booking failed");
        console.error(result);
        return;
      }

      alert("Booked successfully ✅");
      console.log("Success:", result);

      // reset form
      setBookingData({
        fullName: "",
        email: "",
        mobileNumber: "",
        country: "",
        kgs: "",
        shipmentDetails: ""
      });

    } catch (error) {
      console.error("API Error:", error);
      alert("Server not reachable");
    }
  };

  return (
    <section id="bookonline" className="py-5">
      <div className="container">
        <h2 className="text-success fw-bold text-center mb-4">
          Book Your Shipment
        </h2>

        <form
          className="mx-auto"
          style={{ maxWidth: "600px" }}
          onSubmit={handleSubmit}
        >
          <div className="mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Full Name"
              name="fullName"
              value={bookingData.fullName}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-3">
            <input
              type="email"
              className="form-control"
              placeholder="Email"
              name="email"
              value={bookingData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-3">
            <input
              type="tel"
              className="form-control"
              placeholder="Mobile Number"
              name="mobileNumber"
              value={bookingData.mobileNumber}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Country"
              name="country"
              value={bookingData.country}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-3">
            <input
              type="number"
              className="form-control"
              placeholder="Weight (kgs)"
              name="kgs"
              value={bookingData.kgs}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-3">
            <textarea
              className="form-control"
              rows="3"
              placeholder="Shipment Details"
              name="shipmentDetails"
              value={bookingData.shipmentDetails}
              onChange={handleChange}
              required
            />
          </div>

          <button
            type="submit"
            className="btn btn-success rounded-pill w-100"
          >
            Submit
          </button>
        </form>
      </div>
    </section>
  );
}

export default BookOnline;
